// extracted by mini-css-extract-plugin
module.exports = {"slide":"styles_slide__VH5MB"};